import { render } from "./ThemeSubmission.vue?vue&type=template&id=2edfd81c&scoped=true"
import script from "./ThemeSubmission.vue?vue&type=script&lang=js"
export * from "./ThemeSubmission.vue?vue&type=script&lang=js"

import "./ThemeSubmission.vue?vue&type=style&index=0&id=2edfd81c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edfd81c"]])

export default __exports__